module.exports = __webpack_public_path__ + "static/media/AP_ES_Z2.5710cee4.png";